import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import './projects.css'

export default class ProjectServiceRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.service ? props.service.bitValue : false
        };
        this.handleRowCheckedChange = this.handleRowCheckedChange.bind(this);
        this.handleRowDataChange = this.handleRowDataChange.bind(this);
        this.click = this.click.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps && (prevProps.service !== this.props.service || prevProps.service.bitValue !== this.props.service.bitValue)) {
            this.setState({ checked: this.props.service.bitValue});
        }
    }

    click() {
        if (this.props.onSelect) {
            this.props.onSelect(this.props.project.id);
        }
    }

    handleRowCheckedChange = name => evt => {
        this.props.handleChange('bitValue', evt.target.checked);
        this.setState({ checked: evt.target.checked});
    }

    handleRowDataChange = name => evt => {
        this.props.handleChange('value', evt.target.value);
    }

    render() {
        if (!this.props) {
            return <div></div>
        }
        return (
            <div className="project-service-row clearfix">
                <div className="project-service-row-label">{this.props.name}</div>
                <div className="project-service-row-value">
                    {this.props.type === 1 &&
                        <FormControlLabel
                            control={
                            <Checkbox checked={this.state.checked} onChange={this.handleRowCheckedChange('bitValue')} value="true" />
                            }
                            label=""
                        />}

                    {this.props.type === 0 && <TextField required
                        id="standard-fact-required"
                        label=""
                        fullWidth
                        margin="none"
                        multiline
                        rows={4}
                        value={this.props.service.value}
                        onChange={this.handleRowDataChange('value')}
                    />}
                </div>
            </div>
        );
    }
}
